<script setup lang="ts">
import type { RevalidationReferenceBrandUpdatedDisplayRow } from '../revalidationsShared.types'
import { SolAlert } from '@solfacil/girassol'

const props = defineProps<{
  submitContextAttr: string
  rows: RevalidationReferenceBrandUpdatedDisplayRow[]
  isBatch?: boolean
}>()

const alertTitle = computed(() =>
  props.isBatch ? 'Revalidações enviadas com ressalva' : 'Revalidação enviada com ressalva',
)

const alertText = computed(() =>
  props.isBatch
    ? 'As revalidações foram enviadas, mas uma ou mais marcas informadas não fazem parte da campanha vigente. Essas instalações não contam para o progresso da campanha, metas ou benefícios promocionais embora a análise siga normalmente.'
    : 'A revalidação foi enviada, mas a marca do inversor informada não faz parte da campanha vigente. Por isso, ela não conta para o progresso da campanha, metas ou benefícios promocionais embora a análise siga normalmente.',
)

const tableCaption = computed(() =>
  props.isBatch ? 'Instalações afetadas' : 'Instalação afetada',
)
</script>

<template>
  <div
    class="revalidation-submit-modal-step3"
    :data-submit-context="submitContextAttr"
  >
    <SolAlert
      id="revalidation-submit-reference-brand-warning"
      :title="alertTitle"
      :text="alertText"
      feedback="warning"
    />

    <p class="revalidation-submit-modal-step3-table-caption">
      {{ tableCaption }}
    </p>

    <div class="revalidation-submit-modal-table-wrap">
      <table class="revalidation-submit-modal-table">
        <thead>
          <tr>
            <th scope="col" class="revalidation-submit-modal-table-th">
              Nome do projeto
            </th>
            <th scope="col" class="revalidation-submit-modal-table-th">
              Marca informada
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.revalidationId">
            <td class="revalidation-submit-modal-table-td">
              {{ row.projectName }}
            </td>
            <td class="revalidation-submit-modal-table-td">
              {{ row.brandLabel }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.revalidation-submit-modal-step3 {
  @apply flex flex-col gap-5;

  .revalidation-submit-modal-step3-table-caption {
    margin: 0;
    @apply fonts-body-medium-bold text-neutral-low-pure;
  }

  .revalidation-submit-modal-table-wrap {
    @apply w-full overflow-x-auto;
    @apply rounded-md border border-neutral-high-medium bg-neutral-high-pure;

    .revalidation-submit-modal-table {
      @apply w-full border-collapse text-left;

      .revalidation-submit-modal-table-th {
        @apply fonts-body-medium-bold text-neutral-low-pure;
        @apply px-4 py-4 align-middle;
        @apply border border-neutral-high-medium bg-neutral-high-light;
      }

      .revalidation-submit-modal-table-td {
        @apply fonts-body-medium-regular text-neutral-low-pure;
        @apply px-4 py-4 align-top;
        @apply border border-neutral-high-medium;
      }
    }
  }
}
</style>
